import { log } from '@dustin-web/microsite-config/src/logger'
import type { EventDispatcher, EventDispatcherResponse, LogEvent } from '@optimizely/react-sdk'

const skipEvent = (): Promise<EventDispatcherResponse> => Promise.resolve({})

export const createOptimizelyEventDispatcher = (hasAnalyticsConsent: boolean): EventDispatcher => ({
  dispatchEvent: (event: LogEvent): Promise<EventDispatcherResponse> => {
    if (!hasAnalyticsConsent) {
      return skipEvent()
    }

    return fetch(event.url, {
      method: event.httpVerb,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event.params),
    })
      .then(response => ({ statusCode: response.status }))
      .catch(error => {
        log.warn({ error: String(error) }, 'Failed to send Optimizely event')
        return {}
      })
  },
})

export const createOptimizelyClosingEventDispatcher = (
  hasAnalyticsConsent: boolean,
  sendBeaconDispatcher: EventDispatcher | undefined
): EventDispatcher | undefined => {
  if (!sendBeaconDispatcher) {
    return undefined
  }

  return {
    dispatchEvent: (event: LogEvent): Promise<EventDispatcherResponse> =>
      hasAnalyticsConsent ? sendBeaconDispatcher.dispatchEvent(event) : skipEvent(),
  }
}
